/* IE11 safe flex columns */

import { style, space } from 'styled-system';
import styled from '@emotion/styled';
import { omitProps } from '@qga/roo-ui/components';

const rowColGap = style({
  cssProperty: 'margin',
  prop: 'gap',
  transformValue: (gap) => `0 -${gap / 2}px`,
});

const colGap = style({
  cssProperty: 'padding',
  prop: 'gap',
  transformValue: (gap) => `0 ${gap / 2}px`,
});

const cols = style({
  cssProperty: 'maxWidth',
  prop: 'cols',
  transformValue: (columns) => `${(columns / 12) * 100}%`,
});

export const Row = styled('div', omitProps(['gap']))`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  ${rowColGap}
  ${space}
`;

export const Column = styled('div', omitProps(['gap', 'cols']))`
  flex: 1 1 100%;
  ${colGap}
  ${cols}
  ${space}
`;
